import script from "./PlatformPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformPage.vue?vue&type=script&setup=true&lang=js"

import "./PlatformPage.vue?vue&type=style&index=0&id=6e54d7b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e54d7b8"]])

export default __exports__